<!-- @format -->

<div
	class="panel-container"
	[ngClass]="{ 'side-panel-collapsed': !showSidePanel }">
	<div
		class="panel-overlay"
		(click)="closePanel()"></div>
	<div
		class="panel-content {{ panelContentClass }}"
		[ngStyle]="showSidePanel ? panelStyle : null">
		<div
			class="panel-header hmf-pl-m"
			[ngClass]="panelHeaderClass">
			<div class="panel-title">
				<ng-content select="customPanelTitle"></ng-content>
			</div>
			<div class="close-button">
				<button
					type="button"
					class="btn btn-close"
					(click)="closePanel()">
					<homefield-icon name="sign-cancel-outline"></homefield-icon>
				</button>
			</div>
		</div>
		<div
			class="panel-body-container"
			[ngClass]="panelBodyClass">
			<ng-content select="customPanelBody"></ng-content>
		</div>
	</div>
</div>
